<df-list-sub-header
  data-test="search-bar-section"
  (onSearch)="funnelsListService.setFirstPage()"
  [form]="funnelsFilterService.filterFormGroup"
  [searchControlName]="'search'"
  [sortControlName]="'sort'"
  [sorts]="funnelsFilterService.sorts"
></df-list-sub-header>
